import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiButtonBase: Components<Theme>['MuiButtonBase'] = {
  defaultProps: {
    disableRipple: true, // No more ripple, on the whole application 💣!
  },
  styleOverrides: {
    root: {
      '&.Mui-focusVisible': {
        outline: '2px solid var(--mui-palette-text-primary)',
      },
      // do in overwrite by class to avoid type error
      '&.MuiButtonBase-root': {
        textTransform: 'none !important',
        lineHeight: 'normal',

        '.MuiListItemIcon-root': {
          minWidth: scssVariables.SpacingUnit2,
          color: scssVariables.ColorFog100,
        },
      },

      /* Restore pointer events so hover (e.g. tooltips) works on disabled buttons.
       * <button disabled> blocks clicks natively, but <a> has no disabled concept —
       * restoring pointer-events on a disabled <a> would re-enable navigation clicks.
       * For buttons with component={Link} (renders as <a>), we need to use the wrapping element approach for
       * pointer-events restoration for tooltips to show on the "disabled" elements
       */
      '&[disabled], &.Mui-disabled:not(a)': {
        pointerEvents: 'initial',
        cursor: 'not-allowed',
      },
    },
  },
};
